"use client";
// @ts-strict-ignore

import styled from "styled-components";

export const Container = styled.div`
  ${({ theme }) => theme.fullWidthSection};
`;

// The banner now lives on each page and the content below should have no space
export const MainContainer = styled.main<{ mainRelative?: boolean }>`
  ${({ mainRelative }) =>
    mainRelative &&
    ` 
    position: relative;
    overflow-x: hidden;
  `};
  background-color: ${({ theme }) => theme.backgroundColors.primary};
  main {
    &:nth-of-type(2) {
      margin-top: 0px;
    }
  }
`;
